import React from 'react';
import '../styles/NotFound.css';

export default () => (
  <div className="not-found">
    <h3>Sorry, page not found!</h3>
  </div>
);
